import { newE2EPage } from "@stencil/core/testing";

describe("uic-checkbox", () => {
    it("should emit focus events when using clicks", async () => {
        const page = await newE2EPage({
            html: `
            <uic-checkbox>Label</uic-checkbox>
            <button>Other Element</button>`
        });

        const uicBlur = await page.spyOnEvent("uicBlur");
        const uicFocus = await page.spyOnEvent("uicFocus");

        const checkbox = await page.find("uic-checkbox");
        const button = await page.find("button");

        await checkbox.click();

        expect(uicFocus).toHaveReceivedEventTimes(1);

        await button.click();

        expect(uicBlur).toHaveReceivedEventTimes(1);
    });

    it("should emit focus events using focus methods", async () => {
        const page = await newE2EPage({
            html: `<uic-checkbox>Label</uic-checkbox>`
        });

        const uicBlur = await page.spyOnEvent("uicBlur");
        const uicFocus = await page.spyOnEvent("uicFocus");

        const checkbox = await page.find("uic-checkbox");

        await checkbox.callMethod("setFocus");

        expect(uicFocus).toHaveReceivedEventTimes(1);

        await checkbox.callMethod("removeFocus");

        expect(uicBlur).toHaveReceivedEventTimes(1);
    });

    it("should not emit uicChange when setting checked attribute", async () => {
        const page = await newE2EPage({
            html: `<uic-checkbox></uic-checkbox>`
        });
        const checkboxEl = await page.find("uic-checkbox");
        const uicChange = await checkboxEl.spyOnEvent("uicChange");

        checkboxEl.setAttribute("checked", "");
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(0);
        expect(await checkboxEl.getProperty("checked")).toBe(true);
    });

    it("should not emit uicChange when removing checked attribute", async () => {
        const page = await newE2EPage({
            html: `<uic-checkbox checked></uic-checkbox>`
        });
        const checkboxEl = await page.find("uic-checkbox");
        const uicChange = await checkboxEl.spyOnEvent("uicChange");

        checkboxEl.removeAttribute("checked");
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(0);
        expect(await checkboxEl.getProperty("checked")).toBe(false);
    });

    it("should emit uicChange when clicking the checkbox", async () => {
        const page = await newE2EPage({
            html: `<uic-checkbox></uic-checkbox>`
        });
        const checkboxEl = await page.find("uic-checkbox");
        const uicChange = await checkboxEl.spyOnEvent("uicChange");

        checkboxEl.click();
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(1);
        expect(await checkboxEl.getProperty("checked")).toBe(true);
    });
});
